/**
 * This module contains code for State Parameters.
 *
 * See [[ParamDeclaration]]
 *
 * @coreapi
 * @preferred
 * @module params
 */ /** for typedoc */
export * from './interface';
export * from './param';
export * from './paramTypes';
export * from './stateParams';
export * from './paramType';
